'use strict';

var createPixelPlugin = require('../utils/createPixelPlugin.js');

var TwitterPixelPlugin = function TwitterPixelPlugin(_ref) {
  var _ref$publisherId = _ref.publisherId,
    publisherId = _ref$publisherId === void 0 ? null : _ref$publisherId,
    _ref$context = _ref.context,
    context = _ref$context === void 0 ? null : _ref$context,
    _ref$twitter_pixel_id = _ref.twitter_pixel_id,
    twitter_pixel_id = _ref$twitter_pixel_id === void 0 ? null : _ref$twitter_pixel_id,
    _ref$twitter_pixel_ev = _ref.twitter_pixel_event_map,
    twitter_pixel_event_map = _ref$twitter_pixel_ev === void 0 ? {} : _ref$twitter_pixel_ev,
    _ref$enabled = _ref.enabled,
    enabled = _ref$enabled === void 0 ? false : _ref$enabled;
  var provider = 'twitter';
  var scriptSrcTwitter = 'https://static.ads-twitter.com/uwt.js';

  /**
   * Since we do not have a backup sdk for every pixel we plan on using,
   * we instead will check when the window is defined to load the pixel
   */

  var isSSr = typeof window === 'undefined';
  if (isSSr) return {
    name: "analytics-plugin-" + provider + "-pixel"
  };
  var sendTwitterConversionEvent = function sendTwitterConversionEvent(event_id, event_params) {
    if (event_params === void 0) {
      event_params = {};
    }
    var _ref2 = window || {},
      twq = _ref2.twq;
    if (event_id && twq) {
      return window.twq('event', "tw-" + twitter_pixel_id + "-" + event_id, event_params);
    }
  };
  var customTwitterInit = function customTwitterInit() {
    // /**
    //  * Set up twitter tag and event queue
    //  */
    var twitterTrackingLayer;
    if (window && !window.twq) {
      window.twq = function () {
        if (twitterTrackingLayer.exe) {
          twitterTrackingLayer.exe.apply(twitterTrackingLayer, arguments);
        } else {
          twitterTrackingLayer.queue.push(arguments);
        }
      };
      twitterTrackingLayer = window.twq;
    }
    twitterTrackingLayer.version = '1.1';
    twitterTrackingLayer.queue = [];
    window.twq('config', twitter_pixel_id);
  };
  return createPixelPlugin({
    provider: provider,
    publisherId: publisherId,
    context: context,
    enabled: enabled,
    pixelConfig: {
      scriptSrc: scriptSrcTwitter
    },
    coreEvents: {
      initialize: customTwitterInit,
      page: function page(_ref3) {
        _ref3.config;
          _ref3.payload;
        return sendTwitterConversionEvent(twitter_pixel_event_map.page_view);
      },
      identify: function identify(_ref4) {
        _ref4.config;
          var payload = _ref4.payload;
        var _ref5 = (payload === null || payload === void 0 ? void 0 : payload.options) || {},
          type = _ref5.type;
        var _ref6 = (payload === null || payload === void 0 ? void 0 : payload.traits) || {},
          email = _ref6.email;
        if (type === 'user_login') {
          return sendTwitterConversionEvent(twitter_pixel_event_map.creator_signup, {
            email_address: email
          });
        }
        return false;
      }
    }
  });
};
var TwitterPixelPlugin$1 = TwitterPixelPlugin;

module.exports = TwitterPixelPlugin$1;
//# sourceMappingURL=index.js.map
